var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-base",class:{'w-100': _vm.full},attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click'); _vm.$emit('clicked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }